import { createContext, useContext } from "react";
import { type ApolloClientOptions } from "../configs/apollo";
import { ConfigApp } from "../configs/app";
import { type ConfigEnvironment } from "../configs/environment";
import { type ConfigHeaderApplication } from "../configs/header";

export type ConfigContextState = {
  apollo: ApolloClientOptions;
  app: ConfigApp;
  applications: ConfigHeaderApplication[];
  baseUrlApi: string;
  baseUrlApiAnalytics: string;
  environment: ConfigEnvironment;
};

export const defaultConfigContextState: ConfigContextState = {
  apollo: {},
  app: ConfigApp.cms,
  applications: [],
  baseUrlApi: "",
  baseUrlApiAnalytics: "",
  environment: "dev",
};

export const ConfigStateContext = createContext<ConfigContextState>(
  defaultConfigContextState,
);
export const useConfigState = () => useContext(ConfigStateContext);
